import type { ReactNode } from 'react';
import { Images } from '@assets';
import AppImage from '@components/common/Image';
import authRightImgUrl from '../../assets/image/authRightImg.png';

interface AuthCenteredLayoutProps { children: ReactNode; }

function AuthCenteredLayout({ children }: AuthCenteredLayoutProps) {
    return (
        <div className="min-h-screen bg-gray-50 flex flex-col items-center bg-repeat bg-contain bg-center" style={{ backgroundImage: `url(${authRightImgUrl})` }}>
            <div className="mt-[60px] 2xl:mt-[100px] shrink-0 flex items-center justify-center gap-3">
                <AppImage
                    src={Images.tpaLogo}
                    alt="The Purpose Academy"
                    height={50}
                    priority
                    className="select-none object-contain h-12 w-auto"
                />
                <span className="h-8 w-px bg-slate-300" />
                <span className="text-[14px] font-extrabold tracking-[0.18em] text-navy uppercase">
                    AI IMPACT <span className="bg-gradient-to-r from-[oklch(0.55_0.24_295)] via-[oklch(0.62_0.27_0)] to-[oklch(0.72_0.22_35)] bg-clip-text text-transparent">FELLOWSHIP</span>
                </span>
            </div>
            <div className="flex flex-1 items-center justify-center w-full p-4 md:p-6 2xl:p-8">
                <div className="w-full max-w-[400px]">
                    {children}
                </div>
            </div>
        </div>
    );
}

export default AuthCenteredLayout;